<app-kontable
  #table
  *ngIf="!dialogCompanies"
  id="dt_users"
  title="{{ 'userList.sectionTitle' | translate }}"
  [columns]="[
      { field: 'id', title: 'common.id', filterType: numberFilter },
      'login', 'name', 'surname', 'email',
      { field: 'role_desc', bodyTemplate: isUsersTemplate, filterTemplate: isUsersFilter, filterType: customFilter, title: 'common.role' }
  ]"
  [titles]="['userForm.login', 'userForm.name', 'userForm.surname', 'userForm.email']"
  [paginationType]="paginationType"
  [service]="srvUsers"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  [showInfoButton]="false"
  [additionalRowCommands]="customRow"
  [(fireNewDataAvailable)]="newDataAvailable"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)">

  <ng-template #isUsersTemplate data-testid="isUsersTemplate" let-row>
    <span>{{row.role_desc}}</span>
  </ng-template>

  <ng-template #isUsersFilter data-testid="isUsersFilter" let-col>
    <p-dropdown [options]="comboOptions" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
  </ng-template>

  <ng-template #customRow data-testid="customRow" let-row>
    <p-button  *ngIf="row.flg_state !== '9'" pTooltip="{{ 'users.linked_companies' | translate }}" icon="fa fa-building" styleClass="ui-button-info" (onClick)="companiesAction(row)"></p-button>
    <p-button  *ngIf="row.flg_state !== '9'" pTooltip="{{ 'users.reset_password' | translate }}" icon="fa fa-key" styleClass="ui-button-info" (onClick)="openPswResetDialog(row)"></p-button>
    <p-button *ngIf="row.role_type !== 'S' && row.role_type !== 'A' && (authService.user.role === 'S' || authService.user.role === 'A') && row.flg_state !== '9'" pTooltip="{{ 'users.clone' | translate }}" icon="fa fa-clone" styleClass="ui-button-info" (onClick)="openCloneUserDialog(row)"></p-button>
    <p-button *ngIf="(userData.role === 'S' || userData.role === 'A') && row.flg_state !== '9'" pTooltip="{{ 'userForm.impersonification' | translate }}" icon="fa fa-user-circle" styleClass="ui-button-info" (onClick)="openImpersonification(row)"></p-button>
    <!-- Delete per user con flg_state 9 -->
    <p-button pTooltip="{{ 'common.delete' | translate }}" icon="fa far fa-trash" *ngIf="row.flg_state === '9'" styleClass="ui-button-info" (onClick)="delete(row)"></p-button>
    <!--<p-button label="" pTooltip="{{'common.manageAssociations' | translate}}" icon="fa fa-bars" styleClass="ui-button-info" (onClick)="openAssociate(row)"></p-button>-->
  </ng-template>
</app-kontable>

<p-dialog
  id="user-dialog"
  *ngIf="showDialog"
  [(visible)]="showDialog"
  [modal]="true"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()"
  [header]="dialogTitle">
  <app-user-form
    (userAdded)="userAdded($event)"
    (userUpdated)="userUpdated($event)"
    *ngIf="this.srvUsers.userEditing"
    [dialogBoxUser]="this.srvUsers.userEditing"
    [userToClone]="userToClone"
  ></app-user-form>
</p-dialog>

<p-dialog
  *ngIf="showPswDialog"
  [(visible)]="showPswDialog"
  [modal]="true"
  header="{{ 'customers.auth_reset' | translate }}"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="showPswDialog=false">
  <app-user-psw-reset-form (pswResetted)="resetPwdAction($event)"></app-user-psw-reset-form>
</p-dialog>

<app-user-companies
  *ngIf="dialogCompanies"
  [selectedCompanies]="selectedCompanies"
  (onBackPressed)="dialogCompanies = false"
  [activeUser]="userSelected"
  (userCompaniesChanged)="companiesAction($event)"
></app-user-companies>

<p-dialog
  *ngIf="showAssociateDialog"
  [(visible)]="showAssociateDialog"
  [modal]="true"
  header="{{'common.manageAssociations' | translate}} - {{user.name}}"
  [positionTop]="50"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="showAssociateDialog=false">
  <app-associations origin="users"></app-associations>
</p-dialog>

<!-- <div *ngIf="showAssociateDialog" class="ui-g-5">
    <app-user-associations></app-user-associations>
</div> -->





// WEBPACK FOOTER //
// ./src/app/views/administration/users/users.component.html